import Icon from '../components/Icon.vue'

Icon.register({"filter":{"width":512,"height":512,"paths":[{"d":"M488 0H24C2.7 0-8 25.9 7.1 41L192 225.9V432C192 439.8 195.8 447.2 202.2 451.7L282.2 507.6C298 518.7 320 507.5 320 488V225.9L504.9 41C520 25.9 509.3 0 488 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/filter.js
// module id = cAWh
// module chunks = 0